

export interface IStore {
    id: number,
    name: string,
    description: string,
    location: string,
   
    isShowroom: boolean,

    email1: string,
    email2: string,
    portable1: string,
    portable2: string,
    countryCode: string,
    state: string,
    city: string,
    postalCode: string,
    addressLine1: string,
    addressLine2: string,
    addressName: string,

    explicitProductDefinition: boolean,
    linkedToAllStoreDelivery: boolean,
    linkedToAllStoreTransfer: boolean,

    fileName: string,
    base64Picture: string,

    storeCurrencies: IStoreCurrency[],
    storeProductionUnits: IStoreProductionUnit[],
    linkedStores: ILinkedStore[]
  }

  export interface ILinkedStore {
    id: number,
    storeId: number,
    otherStoreId: number,

    allowDelivery: boolean,
    allowTransfer: boolean,

    otherStoreName: string
  }

  export interface IStoreCurrency {
    id: number,

    storeId: number,
    currencyCode: string,
  }

  export interface IStoreProductionUnit {
    id: number,

    storeId: number,
    productionUnitCode: string,
    defaultPrinterName: string
  }

  export const defaultStore : IStore = {
    id: 0,
    name: '',
    description: '',
    location: '',

    isShowroom: false,

    email1: '',
    email2: '',
    portable1: '',
    portable2: '',
    countryCode: '',
    state: '',
    city: '',
    postalCode: '',
    addressLine1: '',
    addressLine2: '',
    addressName: '',

    explicitProductDefinition: false,
    linkedToAllStoreDelivery: true,
    linkedToAllStoreTransfer: true,


    fileName: '',
    base64Picture: '',

    storeCurrencies: [],
    storeProductionUnits: [],
    linkedStores: []
  }


  export interface IStoreSearch {
    name: string,
    description: string,
    location: string
  }